import gql from "graphql-tag";

export const SuppliesBudget = gql`
  query SuppliesBudget ($projectId: String!) {
    project(id: $projectId) {
      id
      name
      startDate
      endDate
      supplies {
        id
        name
        expenseType
        isVerifiable
        humanResource {
          id
          fullName
        }
        monthlyBudget {
          id
          ficosec
          coinvestor
          month
          budgetVerification {
            id
            type
            consumed
            invoices {
              id
              ref
              fileName
            }
          }
        }
      }
    }
  }
`;
